export default "__VITE_ASSET__7X6FAleS__"